import "@/styles/main.scss"
import { createVuetify } from "vuetify"
import { aliases, mdi } from "vuetify/iconsets/mdi-svg"

import {
  mdiPower,
  mdiCheckCircleOutline,
  mdiInformationOutline,
  mdiProgressClock,
  mdiHelpCircle,
  mdiViewDashboard,
  mdiReceiptText,
  mdiChevronLeft,
  mdiChevronUp,
  mdiFileDownload,
  mdiMagnify,
  mdiCogBox,
  mdiAccountBox,
  mdiShieldAccount,
  mdiCreditCardCheck,
  mdiPlus,
  mdiClose,
  mdiTable,
  mdiCardBulletedOutline,
  mdiFolder,
  mdiFolderOpen,
  mdiFileUpload,
  mdiFileImage,
  mdiFileDocument,
  mdiPlusBox,
  mdiDotsVertical,
  mdiChevronDown,
  mdiMenuRight,
  mdiEye,
  mdiEyeOff,
  mdiRefresh,
  mdiRouterNetwork,
} from "@mdi/js"

import logo from "@/assets/logo"

const icons = {
  defaultSet: "mdi",
  aliases: {
    ...aliases,
    mdiPower,
    mdiCheckCircleOutline,
    mdiInformationOutline,
    mdiProgressClock,
    mdiHelpCircle,
    mdiViewDashboard,
    mdiReceiptText,
    mdiChevronLeft,
    mdiChevronUp,
    mdiFileDownload,
    mdiMagnify,
    mdiCogBox,
    mdiAccountBox,
    mdiShieldAccount,
    mdiCreditCardCheck,
    mdiPlus,
    mdiClose,
    mdiTable,
    mdiCardBulletedOutline,
    logo,
    mdiFileUpload,
    mdiDotsVertical,
    mdiChevronDown,
    mdiFolder,
    mdiMenuRight,
    mdiFolderOpen,
    mdiFileDocument,
    mdiPlusBox,
    mdiFileImage,
    mdiEye,
    mdiEyeOff,
    mdiRefresh,
    mdiRouterNetwork,
  },
  sets: {
    mdi,
  },
}

const vuetify = createVuetify({
  defaults: {
    VTextField: {
      color: "primary",
      variant: "underlined",
    },
    // todo: set primary color for just selected btn
    VRadioGroup: {
      color: "primary",
      VRadio: {
        VIcon: {
          color: "primary",
        },
      },
    },
    VStepperItem: {
      color: "primary",
      VIcon: {
        color: "white",
      },
    },
    VSelect: {
      variant: "underlined",
    },
    VAutocomplete: {
      variant: "underlined",
    },
    VBtn: {
      color: "primary",
    },
    VProgressLinear: {
      color: "primary",
    },
    VCard: {
      style: "border-color: rgba(0,0,0,.12);",
    },
    VSwitch: {
      color: "primary",
    },
    VProgressCircular: {
      indeterminate: true,
      color: "primary",
    },
    VAlert: {
      border: "start",
      variant: "tonal",
      density: "compact",
    },
  },
  theme: {
    defaultTheme: "myCustomTheme",
    themes: {
      myCustomTheme: {
        dark: false,
        colors: {
          "primary": "#0f67ff",
          "primary-lighten-1": "#2678FF",
          "primary-lighten-2": "#478EFF",
          "primary-lighten-3": "#74abff",
          "primary-lighten-4": "#e4efff",
          "primary-lighten-5": "#f5f9ff",
          "primary-darken-1": "#0141AF",
          "primary-darken-2": "#022662",
          "primary-darken-3": "#031B45",
          "secondary": "#050F34",
          "accent": "#0f67ff",
          "info": "#787B87",
          "success": "#149F5C",
          "warning": "#F07000",
          "error": "#E3063D",
          "background": "#F9F9FA",
          "on-background": "#050F34",
        },
      },
    },
  },
  icons,
})

export {
  vuetify,
  icons,
}
